'use client';

import HIHImage from '@/components/base/HIHImage';
import { ARIA_LABEL_MAIN_NAV, SITE_NAME } from '@/shared/constants';
import React, { useState } from 'react';
import { ArticleCard } from '@/sanity/fetchArticles';
import { CategoryLink } from '@/sanity/fetchCategories';
import { Header as HeaderType } from '@/sanity/fetchLayout';
import NavigationMainMenu from './NavigationMainMenu';
import HIHLink from '@/components/base/Link';
import styles from './Navigation.module.scss';

function IconBurger() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M3 18H21V16H3V18ZM3 13H21V11H3V13ZM3 6V8H21V6H3Z" fill="#1D1B20" />
    </svg>
  );
}

interface NavigationProps {
  header: HeaderType;
  articles?: ArticleCard[];
  categories?: CategoryLink[];
}

const Navigation: React.FC<NavigationProps> = ({ header, articles, categories }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const id = 'main-menu';

  return (
    <nav aria-label={ARIA_LABEL_MAIN_NAV} className={styles.nav}>
      <div className={styles.logoRow}>
        <HIHLink href="/" title="Startseite">
          <HIHImage
            image={header.logo}
            alt={`Logo ${SITE_NAME}, zur Startseite`}
            width={142}
            height={32}
            className={styles.logo}
          />
        </HIHLink>

        <button
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          className={styles.burgerButton}
          aria-expanded={isMenuOpen}
          aria-controls={`#${id}`}
          aria-label={ARIA_LABEL_MAIN_NAV}
        >
          <IconBurger />
        </button>
      </div>

      <NavigationMainMenu
        id={id}
        appCta={header.appCta}
        menu={header.menu}
        articles={articles}
        categories={categories}
        isMenuOpen={isMenuOpen}
      />
    </nav>
  );
};

export default Navigation;
